<template>
  <div class="parent-box">
      <modal-main v-if="showModal" @close="showModal = false">
      <h4 slot="header">
        Search Transaction History
      </h4>
      <div slot="body" style="width: 100%;">
        <form>
          <select class="form-control">
            <option>Select</option>
            <option>Account</option>
            <option>Transaction Ref</option>
            <option>Al Customers</option>
            <option>Successful Onboarded</option>
          </select>
        </form>
        <div class="pt-4 text-right">
              <button type="button" @click="showModal = true" class="btn btn-warning btn-sm">Search</button>
        </div>
      </div>
    </modal-main>
    <!-- step 1 -->
    <div class="container">
      <h2 class="page-header">Customer Transaction History</h2>
      
    </div>
     <div class="text-right">
              <button type="button" @click="showModal = true" class="btn btn-warning btn-sm">Search</button>
              </div>


      <table class="table table-bordered">
        <br />

        <tr>
          <th class="text-nowrap mr-5">Transaction Type</th>
          <th class="text-nowrap mr-5 go-right text-left pr-5">
            Transaction Reference
          </th>
          <th class="text-nowrap mr-5 go-righty text-left">Payment Amount</th>
                    <th class="text-nowrap mr-5 go-righty text-left">Transaction Date</th>
          <th class="text-nowrap">Transaction Status</th>
        </tr>
        <tr v-for="item in datas" :key="item.id">
          <td class="mr-5 text-nowrap text-center">
            {{ item.transactionType }}
          </td>
          <td class="mr-5 text-nowrap text-center">
            {{ item.transactionReference }}
          </td>
          <td class="mr-5 text-nowrap text-center">{{ item.paymentAmount }}</td>
          <td class="mr-5 text-nowrap text-center">{{ item.createdAt && item.createdAt.slice(0,10)}}</td>
          <td class="mr-5 text-nowrap">{{ item.status }}</td>

        </tr>
      </table>
   
    <div class="footer">
      <!-- real footer item -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import ModalMain from './Modal';

export default {
  name: "FinishTab",
  props: {
    getUserSession: null,
  },
  components: {
      ModalMain
  },
  computed: {},
  data() {
    return {
      form: {
        bvn: "",
      },
      formErrors: {},
      datas: [],
      datar: [],
      showModal: true,
      show1: true,
      show2: false,
      // activeIndex: 0,
      summary: {},
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    showFirst() {
      this.show1 = true;
      this.show2 = false;
    },

    showSecond() {
      (this.show1 = false), (this.show2 = true);
    },
    getCustomers() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/transactionHistories`
        )
        .then((res) => {
          this.datas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getThis() {
      axios
        .get(
          `https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/recurringPaymentSetups`
        )
        .then((res) => {
          this.datar = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  async mounted() {
    this.getCustomers();
    this.getThis();
  },
};
</script>

<style lang="scss" scoped>
.tray-show {
  background-color: #000;
  color: white;
  border: 1px solid #000;
  height: 5rem;
  padding: 10px 0px;
  width: 100%;
}

.active-link{
  color: #ffb946;
  margin-left: 1rem;
}

.right-space {
  padding-right: 10rem;
}

.cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customer-admin/Transactions.vue